import Head from "expo-router/head";
import { useContext } from "react";

import WorkwhileLogo from "@/assets/images/workwhile-logo.png";
import { LayoutContext, ScrollView } from "@/components";
import { WORKWHILE_EVENTS } from "@/config/adConversionEvents";
import { brandName } from "@/config/brand";
import GeneralCareLandingPage, {
  type PartnerLandingConfig,
} from "@/landing-page/general-care/GeneralCareLandingPage";

const WORKWHILE_CONFIG: PartnerLandingConfig = {
  welcomeChip: {
    prefix: "Welcome",
    partnerName: "WorkWhile",
    suffix: "members",
    backgroundColor: "$workwhileMint",
    textColor: "$textPrimary",
    logo: WorkwhileLogo,
    logoWidth: 79,
    logoHeight: 15,
    logoTintColor: "$textPrimary",
  },
  visitedSplashEventName: WORKWHILE_EVENTS.visitedSplashScreen,
};

export default function WorkwhileLandingPage() {
  const { headerHeight } = useContext(LayoutContext);
  return (
    <>
      <Head>
        <title>{`WorkWhile — ${brandName}`}</title>
      </Head>
      <ScrollView
        contentContainerStyle={{
          flexGrow: 1,
          paddingTop: headerHeight.current,
        }}
        keyboardShouldPersistTaps="handled"
        showsVerticalScrollIndicator={false}
        backgroundColor="$backgroundGround"
      >
        <GeneralCareLandingPage partnerConfig={WORKWHILE_CONFIG} />
      </ScrollView>
    </>
  );
}
